import { Modal } from '@mui/material'
import { styled } from 'styled-components'

export const ScrollWrapper = styled.div<{ height?: string }>`
  //overflow: scroll;
  height: ${({ height }) => (height ? height : '100%')};
  width: 100%;
`

export const SignalLevel = styled.div<{color?:any}>`
  border-radius: 100px;
  color: ${({ color }) => color?.textColor || color?.color};
  border: ${({ color }) => `2px solid ${color?.color}`};
  background: ${({ color }) => color?.background};
  display: flex;
  padding: 1px 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: max-content;
  margin-right: 5px;
  cursor: pointer;
  font-size: 12px;
font-style: normal;
font-weight: 600;
  :hover {
    text-decoration: none!important;
  }
`

export const Button = styled.div`
cursor: pointer;
  padding: 2px 5px;
  border-radius: 100px;
  border: 1px solid #ededed;
  background: #f7f7f7;
  width: fit-content;
  margin-right: 10px;
  min-width: 100px;
  text-align: center;
`
export const FlexBlock = styled.div`
    display: inline-flex;
    width: 100%;  /* or max-width if you prefer */

  p {
    word-break: break-all;
    margin-left: 10px;
  }
`
export const ConnectModal = styled(Modal)`
  display: flex;
  justify-content: center;
  padding-top: 100px;
  padding-bottom: 100px;
  overflow: auto;
  //align-items: center;
  > div {

    border-radius: 4px;
    padding: 0px 8px;
  }
`
